import React from "react";

/**
 * <SEO> — per-route <title>, <meta description>, and og/twitter tags.
 *
 * Uses React 19's native <head> tag hoisting: when <title> / <meta> / <link>
 * elements are rendered anywhere in the tree, React 19 automatically moves
 * them into <head> and de-duplicates by name/property. No react-helmet-async
 * needed.
 *
 * Usage inside a page component:
 *     <SEO title="Sovereign Audit — Green Gold Energy" description="…" />
 */
export default function SEO({ title, description, robots }) {
  return (
    <>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {robots && <meta name="robots" content={robots} />}

      {/* Open Graph — mirrors title/description into social embeds. */}
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}

      {/* Twitter card — mirrors again for X. */}
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
    </>
  );
}
